export default __webpack_public_path__ + "static/char-v-45-zh-Hant-4ca9fa100181cc1be8239450a11d91d1.mp4";